// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"text_ellipsis__2gD2w","noWrap":"text_noWrap__2iEso","lineThrough":"text_lineThrough__21_aT","redText":"text_redText__1BMQw","greenText":"text_greenText__4A5c4"};